
import inputMixin from './input-mixin'
import Visual from 'vue-visual'

export default
	components: { Visual }

	mixins: [ inputMixin ]

	props:

		# List of options
		options:
			type: Array
			default: -> []

		# List of options sorted by group
		optionsByGroup:
			type: Object

		# Automatically add the label as the first select option
		addLabelAsOption:
			type: Boolean
			default: true

		# The size of the arrow
		arrowSize:
			type: String
			validator: (val) -> val in ["short", "long"]
			default: "short"

		# Used to force focus class from parent component
		forceFocus:
			type: Boolean
			default: false

		# Used to force hover class from parent component
		forceHover:
			type: Boolean
			default: false

		# Select icon to show
		icon:
			type: String
			default: "arrow"
			validator: (val) -> val in ["chevron", "arrow", "none"]

	data: ->
	 	# if the input has focus
		hasFocus: false

		# if the input is being hovered on
		isHover: false

	computed:

		# Merge the label with the list of options
		renderedOptions: -> [
			if @addLabelAsOption then { label: @label, value: undefined } else undefined
			...@options.map @mapOption
		].filter (option) -> !!option

		# The component classes
		classes: -> [
			if @hasFocus || @forceFocus then 'has-focus'
			if @isHover || @forceHover then 'hover'
		]

		computedOptionsByGroup: ->
			[
				if @addLabelAsOption then { label: @label, value: undefined } else undefined
			]

	methods:

		# Convert simple object to expected pattern
		mapOption: (option) ->
			if 'object' == typeof option then option
			else { label: option, value: option }

		# Handle and alert parent of focus event
		onFocus: ->
			@hasFocus = true
			@$emit 'focus'

		onBlur: ->
			@hasFocus = false
			@$emit 'blur'

		# Handle and alert parent of hover events
		enterHover: ->
			@isHover = true
			@$emit 'hover'

		leaveHover: ->
			@isHover = false
			@$emit 'leave-hover'


